import { render, staticRenderFns } from "./BarChartComponent.vue?vue&type=template&id=15f356dc&scoped=true"
import script from "./BarChartComponent.vue?vue&type=script&lang=js"
export * from "./BarChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f356dc",
  null
  
)

export default component.exports